import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useVendorsApi() {
    const callApi = useApiCall();

    return {
        addUpdateVendor: apiCaller(callApi, SAGA_ACTIONS.VENDORS.ADD_UPDATE_VENDOR),
        deleteVendor: apiCaller(callApi, SAGA_ACTIONS.VENDORS.DELETE_VENDOR),
        searchVendor: apiCaller(callApi, SAGA_ACTIONS.VENDORS.SEARCH_VENDOR),
        vendorDetails: apiCaller(callApi, SAGA_ACTIONS.VENDORS.VENDOR_DETAILS),
        checkSKUUnique: apiCaller(callApi, SAGA_ACTIONS.VENDORS.CHECK_SKU_UNIQUE),
    };
}
